import { forwardRef } from 'react';
import { ButtonBase, SvgIcon, TabScrollButtonProps } from '@mui/material';
import ScrollArrowLeftIcon from '../../../../../../icons/svg/scroll_arrow_left.svg?react';
import ScrollArrowRightIcon from '../../../../../../icons/svg/scroll_arrow_right.svg?react';

type Props = TabScrollButtonProps;

const CustomTabScrollButton = forwardRef<HTMLDivElement, Props>((props, ref) => {
  const { direction, ...other } = props;
  const iconComponent = direction === 'left' ? ScrollArrowLeftIcon : ScrollArrowRightIcon;

  return (
    <ButtonBase
      disableTouchRipple
      component="div"
      ref={ref}
      style={{ opacity: other.disabled ? 0 : 1 }}
      {...other}
    >
      <SvgIcon
        component={iconComponent}
        fontSize="small"
        color="primary"
        sx={{
          '&:hover': {
            color: 'grey.900'
          }
        }}
      />
    </ButtonBase>
  );
});

export default CustomTabScrollButton;
